import { observable, computed, runInAction } from 'mobx';
import { post } from '../utils';
import { toast } from '../components';

class orderDetail {
    static PAGE_SIZE = 10;
    private route: string;
    private params: any;
    @observable
    public firstFetched: boolean = false;
    @observable
    public isEmpty: boolean = false;
    @observable
    public lists: any;
    public list: any = [];
    @observable
    public page: any = 1;
    @observable
    public isLoadOk: any = '';

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    updateParams(key, val) {
        this.params[key] = val;
    }

    @observable
    private isLastPage: boolean = true;

    @computed
    get canFetch() {
        if (this.isEmpty) {
            return false;
        }
        return !this.isLastPage;
    }

    fetch(callback) {
        let obj = Object.assign(this.params);
        post(this.route, obj).then((d) => {
            if (d.errCode == 400) {
                toast(d.errDesc);
                return;
            }
            this.firstFetched = true;
            let data: any = d.data;
            runInAction(() => {
                this.lists = data;
            });
            callback(d);
        });
    }
}

export default orderDetail;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/orderDetail.ts